// fits the longest formatDate output ("Dec 28, 2023, 10:59 PM") at the app's letter spacing, with a little room to spare
export const DATE_COLUMN_WIDTH = 210

// widest a flexible name-like text column grows. Wide enough for long real names; past it, a wide screen's spare space
// collects after the last column instead of opening a gap in the middle of the table
export const NAME_COLUMN_MAX_WIDTH = 320

// fits a four-digit id with the header's sort arrow
export const ID_COLUMN_WIDTH = 80
